import script from "./Home-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Home-big.vue?vue&type=script&setup=true&lang=js"

import "./Home-big.vue?vue&type=style&index=0&id=694e8478&lang=css"
import "./Home-big.vue?vue&type=style&index=1&id=694e8478&lang=css"
import "./Home-big.vue?vue&type=style&index=2&id=694e8478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694e8478"]])

export default __exports__